import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'routeStartHour' })
export class RouteStartHourPipe implements PipeTransform {
  transform(stationIndexTime: any) {
    if (!stationIndexTime.hasOwnProperty(0)) {
      return { hour: '', class: '' };
    }
    let hour = stationIndexTime[0];
    let hourClass = '';
    if (hour < 0) {
      hour = 24 + hour;
      hourClass = 'hour-warn';
    }
    return { hour: hour + ':00', class: hourClass };
  }
}
